import ThisModule from "./StepPrice";

export default ThisModule;
